import { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import Hero from '../sections/Hero'
import Approach from '../sections/Approach'
import ImpactCases from '../sections/ImpactCases'
import ResearchTeaser from '../sections/ResearchTeaser'
import PilotDemo from '../sections/PilotDemo'
import ProjectJourney from '../sections/ProjectJourney'
import FinalCTA from '../sections/FinalCTA'

const isFigmaExport =
  typeof window !== 'undefined' &&
  (window.location.pathname === '/figma-export' ||
    window.location.pathname === '/figma-export/')

export default function Landing() {
  useEffect(() => {
    if (isFigmaExport) {
      document.documentElement.classList.add('figma-export-mode')
      document
        .querySelectorAll('[data-reveal]')
        .forEach((el) => el.classList.add('visible'))
      return
    }

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('visible')
            obs.unobserve(e.target)
          }
        })
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    )
    document.querySelectorAll('[data-reveal]').forEach((el) => obs.observe(el))
    return () => obs.disconnect()
  }, [])

  return (
    <>
      <Helmet>
        <title>MODELLER — ML that proves the result first</title>
        <meta
          name='description'
          content='We validate your business hypothesis on your data and show measurable impact before full delivery. Modeller owns the whole cycle: data, model, integration, monitoring, and production support.'
        />
      </Helmet>
      <Hero />
      <Approach />
      <ImpactCases />
      <ResearchTeaser />
      <PilotDemo />
      <ProjectJourney />
      <FinalCTA />
    </>
  )
}
